import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <Link to="/" style={{ color: '#61dafb', textDecoration: 'none', marginBottom: '20px', display: 'inline-block' }}>
        ← Back to Home
      </Link>
      
      <h1>Privacy Policy</h1>
      <p><em>Last updated: December 12, 2025</em></p>

      <section style={{ marginTop: '30px', lineHeight: '1.8' }}>
        <p>
          We provide an internal workforce tool that reads patient data from PointClickCare via FHIR/SMART to support wound-care documentation preparation.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          We access only the data needed for this purpose (minimum necessary).
        </p>
        
        <p style={{ marginTop: '20px' }}>
          Data may be temporarily processed and may be stored as generated report outputs for X days; raw FHIR payloads are not retained unless explicitly enabled.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          We encrypt ePHI in transit and at rest, restrict access by role, and maintain audit logs of access and exports.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          We do not disclose PHI except to approved subcontractors under a Business Associate Agreement, or as required by law.
        </p>
        
        <p style={{ marginTop: '20px' }}>
          Security incidents and breaches are handled under the incident response process and coordinated with the covered entity per applicable breach notification requirements.
        </p>
      </section>

      <div style={{ marginTop: '50px', paddingTop: '20px', borderTop: '1px solid #ddd' }}>
        <Link to="/legal/terms" style={{ color: '#61dafb', textDecoration: 'none' }}>
          View Terms of Service →
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
